import { h } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";

import {
    Box,

    Popover,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import WarningIcon from '@mui/icons-material/Warning';

import { DatePicker } from '@mui/x-date-pickers';
import InfoIcon from '@mui/icons-material/Info';

import { parseISO } from "date-fns";

export default function FormDate({ upperState, id, handleChange, helper, key, disabled }) {
    console.log("Formdate")
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const value = upperState[id];
    const mnd = upperState[id + "_mnd"];
    const label = upperState[id + "_lbl"];
    const open = Boolean(anchorEl);

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">

            <Box display="flex" justifyContent="flex-start" alignItems="center">
                <Box p={1}>
                    <InfoIcon aria-haspopup="true"
                        aria-owns={open ? 'mouse-over-popover' : undefined}
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}
                        style="margin-top: 6px;"
                        color={helper ? "" : "disabled"}
                    />
                    <Popover
                        id="mouse-over-popover"
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{helper ? helper : <em>Pas encore d'aide, déso</em>}</Typography>
                    </Popover>
                </Box>
                <Box p={1}>
                    <Typography variant="body1">{label} {mnd ? "*" : null}</Typography>
                </Box>
                <Box p={1}>
                    {upperState[id + "_fld"] ? <Tooltip title="Ce champ est obligatoire"><WarningIcon color="primary" /></Tooltip> : ""}
                </Box>
            </Box>
            <Box >
                <DatePicker
                    id={id}
                    name={id}
                    inputFormat="dd/MM/yyyy"
                    disablePast
                    disabled={disabled}
                    //openTo="month"
                    // views={['year', 'month', 'day']}
                    value={value ? value : parseISO(new Date())}
                    onChange={(date) =>
                        handleChange({
                            target: { name: id, value: date.toISOString() },
                        })
                    }
                    renderInput={(params) => <TextField size="small" placeholder="jj/mm/aaaa" style="max-width: 150px;" {...params} />}
                />
                {/* <TextField
                    id={id}
                    name={id}
                    key={key}
                    style={{ width: 75 }}
                    placeholder={placeholder}
                    onChange={handleChange}
                    disabled={disabled}
                    margin="normal"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    variant="outlined"
                    value={value !== 0 ? value : ""}
                    size="small"
                    InputProps={num ? {
                        inputComponent: NumberFormatCustom,
                    } : null}
                /> */}

            </Box>
        </Box>
    );
}
